import { render, staticRenderFns } from "./PsChatWidget.vue?vue&type=template&id=33acf3d8&scoped=true&"
import script from "./PsChatWidget.vue?vue&type=script&lang=js&"
export * from "./PsChatWidget.vue?vue&type=script&lang=js&"
import style0 from "./PsChatWidget.vue?vue&type=style&index=0&id=33acf3d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33acf3d8",
  null
  
)

export default component.exports